var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-icon"},[_c('icon',{attrs:{"icon":_vm.icon ? _vm.icon.name : 'icon-circle',"size":_vm.icon ? '20px' : '12px',"icon-pack":_vm.icon ? _vm.icon.iconType : 'feather'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }